module.exports = __webpack_public_path__ + "static/media/6stats-579w.8fb4d2fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/6stats-579w.jpg
// module id = 30
// module chunks = 0